'use strict';

const e = React.createElement;

function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

class OrderDisplay extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleSaveRevertForm", () => {
      $("#load-wrapper").show();
      this.setState({
        loading: true
      });
      fetch("https://iheartzshop-api-2.herokuapp.com/v1/draft-order/public/update", {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(this.state.revertForm)
      }).then(res => res.json()).then(result => {
        setTimeout(()=>window.location.reload(),4000);
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      error => {
        console.log(error);
        this.setState({
          isLoaded: true,
          error
        });
      }).finally(() => setTimeout(() => this.setState({
        loading: false
      }), 700));
    });
    _defineProperty(this, "handleShowOrderDetail", index => {
      let show = this.state.show;
      show[index] = !show[index];
      this.setState([...show]);
    });
    _defineProperty(this, "handleRevertForm", e => {
      this.setState({
        revertForm: {
          ...this.state.revertForm,
          [e.target.name]: e.target.value
        }
      });
    });
    _defineProperty(this, "checkSVG", /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 352.62 352.62",
      width: "10px",
      height: "10px",
      fill: "white",
      style: {
        margin: "2.5px 2px 4px 2px"
      }
    }, /*#__PURE__*/React.createElement("path", {
      d: "m337.22 22.952c-15.912-8.568-33.66 7.956-44.064 17.748-23.867 23.256-44.063 50.184-66.708 74.664-25.092 26.928-48.348 53.856-74.052 80.173-14.688 14.688-30.6 30.6-40.392 48.96-22.032-21.421-41.004-44.677-65.484-63.648-17.748-13.464-47.124-23.256-46.512 9.18 1.224 42.229 38.556 87.517 66.096 116.28 11.628 12.24 26.928 25.092 44.676 25.704 21.42 1.224 43.452-24.48 56.304-38.556 22.645-24.48 41.005-52.021 61.812-77.112 26.928-33.048 54.468-65.485 80.784-99.145 16.524-20.808 68.544-72.217 27.54-94.248zm-310.28 164.63c-0.612 0-1.224 0-2.448 0.611-2.448-0.611-4.284-1.224-6.732-2.448 1.836-1.224 4.896-0.612 9.18 1.837z"
    })));
    _defineProperty(this, "wrapper", () => {
      const groupedContent = this.state.draftOrder.reduce((accumulator, currentValue) => {
        const currentDate = moment(currentValue.createdAt).format("YYYY-MM-DD");
        if (accumulator.hasOwnProperty(currentDate)) {
          accumulator[currentDate].push(currentValue);
          return accumulator;
        } else return {
          ...accumulator,
          [currentDate]: [currentValue]
        };
      }, {});
      let displayContent = [];
      let customIndex = 0;
      for (const [key, value] of Object.entries(groupedContent)) {
        displayContent.push( /*#__PURE__*/React.createElement("div", {
          style: {
            padding: "1em 1em 1em 1em",
            marginBottom: "4px"
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement("p", {
          style: {
            margin: "1em 0"
          },
          className: "bold"
        }, moment(key).locale("zh_cn").format("llll")), /*#__PURE__*/React.createElement("div", null, value.length, " \u500B\u8A02\u55AE")), /*#__PURE__*/React.createElement("ul", null, value.map((d, i) => this.orderBody(d, i + customIndex)))));
        customIndex += value.length;
      }
      return displayContent;
    });
    _defineProperty(this, "orderBody", (order, index) => {
      return /*#__PURE__*/React.createElement("li", {
        className: order.order_status == '6' ? 'voided' : '',  
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start"
        }
      }, /*#__PURE__*/React.createElement("h4", {
        className: "bold"
      }, "\u8A02\u55AE ", order.name + (order.order_status == '6' ? " ( 訂單已取消 )" : "") , " ", order.tags.indexOf("BUY+1") >= 0 && /*#__PURE__*/React.createElement("label", {
        style: {
          marginLeft: "8px",
          backgroundColor: "lightgrey",
          padding: "4px 0.8em",
          borderRadius: "25px",
          opacity: 0.8,
          fontSize: "80%"
        }
      }, "BUY+1")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        class: "clipboard outline icon"
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "2fr 1fr"
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
        className: "bold"
      }, "\u9810\u8A08\u5230\u9054\uFF1A", order.order_status == 4 ? "您的包裹在處理中，美國出貨後就會有預計到達時間，請耐心等待。" : " ", order.printedAt ? moment(order.printedAt).add("days", 5).format("DD/MM") + " - " + moment(order.printedAt).add("days", 7).format("DD/MM") : " - ", " "), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "small-text"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          minWidth: "63px",
          display: "inline-block"
        }
      }, "\u5546\u54C1\u6578\u91CF", " "), /*#__PURE__*/React.createElement("b", null, "x ", order.line_items.length))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "small-text"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          minWidth: "63px",
          display: "inline-block"
        }
      }, "\u8A02\u55AE\u7E3D\u984D\uFF1A", " "), /*#__PURE__*/React.createElement("b", null, "$", " ", order.order_status == 3 && order.paid_order ? order.paid_order.total_price_twd : order.total_price_twd))), /*#__PURE__*/React.createElement("div", {
        className: "order_note",
        style: {
          margin: "1em 0",
          padding: "8px 0",
          fontWeight: "bold"
        }
      }, order.out_note && /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("i", {
        class: "info circle red icon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "small-text",
        style: {
          fontSize: "14px"
        }
      }, order.out_note, " ")), order.paid_order && order.paid_order.financial_status !== "paid" && order.paid_order.tags.indexOf("REPORTED") >= 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: "center"
        }  
      }, /*#__PURE__*/React.createElement("i", {
        class: "info circle red icon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "small-text"
      }, "\u56DE\u5831\u532F\u6B3E\u6210\u529F\uFF0C\u8ACB\u8010\u5FC3\u7B49\u5019\u532F\u6B3E\u78BA\u8A8D\u3002"))))), /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "right"
        }
      }, (order.order_status === 3 || order.order_status === 3 && order.paid_order && order.paid_order.financial_status !== "paid") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        disabled: order.paid_order && order.paid_order.tags.indexOf("REPORTED") >= 0,
        onClick: () => {
          if (order.paid_order) {
            //回報
            //order.paid_order.financial_status != "paid"
            this.setState({
              loading: true,
              revertForm: {
                id: order.paid_order.id,
                tags: order.paid_order.tags
              }
            });
            setTimeout(() => this.setState({
              loading: false
            }), 1000);
          } else window.location.replace("https://iheartz.shop/pages/ready-to-checkout?d=" + order.id);
        }
      }, order.paid_order ? order.paid_order.financial_status !== "paid" ? order.paid_order.tags.indexOf("REPORTED") >= 0 ? "回報成功" : "回報匯款" : "" : "付款訂單"), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("button", {
        onClick: () => this.handleShowOrderDetail(index)
      }, "\u8A02\u55AE\u8A73\u7D30"))), /*#__PURE__*/React.createElement("div", null, this.orderDetail(order.line_items, order.shipping_address, order.paid_order && order.paid_order.total_shipping_price_set && order.paid_order.total_shipping_price_set.amount_twd, index)), this.state.revertForm.id && order.paid_order && this.state.revertForm.id === order.paid_order.id && this.revertForm(), /*#__PURE__*/React.createElement("div", null, this.timeline(order.order_status)));
    });
    _defineProperty(this, "timelineButton", (status, index, text) => /*#__PURE__*/React.createElement("div", {
      className: `timeline--button-containter ${!(status > index) && "active"}`
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: `timeline--button ${status >= index && "active"} ${status === index && "check"}`
    }, status === index && this.checkSVG), /*#__PURE__*/React.createElement("div", {
      className: status === index && "check"
    }, /*#__PURE__*/React.createElement("small", {
      className: "small-text",
      style: {
        marginLeft: text.length === 2 ? "-3px" : "-8px"
      }
    }, text)))));
    _defineProperty(this, "timeline", status => {
      return /*#__PURE__*/React.createElement("div", {
        className: "timeline"
      }, this.timelineButton(status, 1, "下單"), this.timelineButton(status, 2, "採購中"), this.timelineButton(status, 3, "付款"), this.timelineButton(status, 4, "待出貨"), this.timelineButton(status, 5, "已寄出"));
    });
    _defineProperty(this, "singleItem", item => /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "8px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.picture,
      style: {
        width: "32px",
        height: "32px",
        marginRight: "8px",
        padding: "4px 0"
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "small-text",
      style: {
        fontSize: '14px'
      }
    }, item.name), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", {
      className: "small-text",
      style: {
        fontSize: '14px'
      }
    }, "$ ", item.price_twd, " x ", item.quantity))), /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: "nowrap"
        }
      }, "$ ", item.sub_total_twd)));
    _defineProperty(this, "revertForm", () => !this.state.loading ? /*#__PURE__*/React.createElement("div", {
      className: "revert_form",
      style: {
        padding: "1em 1em 2em 0"
      }
    }, /*#__PURE__*/React.createElement("p", null, "\u8ACB\u4EE5\u8A02\u55AE\u91D1\u984D\u56DE\u5831\u532F\u6B3E\uFF0C\u4E0D\u8981\u591A\u532F\u6216\u5C11\u532F\u55B2 \uFF01"), /*#__PURE__*/React.createElement("p", null, "822 \u4E2D\u570B\u4FE1\u8A17 \u65B0\u7AF9\u5206\u884C ", /*#__PURE__*/React.createElement("br", null), " \u5E33\u865F 299541074982 ", /*#__PURE__*/React.createElement("br", null), " \u8449\u6708\u5A25"), /*#__PURE__*/React.createElement("div", {
      className: "ui tiny form"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u540D\u5B57"), /*#__PURE__*/React.createElement("input", {
      name: "acc_name",
      type: "text",
      placeholder: "",
      onChange: this.handleRevertForm
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u5E33\u6236\u6700\u5F8C\u4E94\u78BC"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: "last_5_digit",
      placeholder: "",
      maxlength: "5",
      onChange: this.handleRevertForm
    }))), /*#__PURE__*/React.createElement("div", {
      class: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u5099\u8A3B"), /*#__PURE__*/React.createElement("textarea", {
      name: "note",
      rows: "3",
      onChange: this.handleRevertForm
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%",
        backgroundColor: "grey"
      },
      onClick: () => this.setState({
        revertForm: {}
      })
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%"
      },
      onClick: () => this.handleSaveRevertForm()
    }, "\u56DE\u5831\u532F\u6B3E")))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
      class: "spinner loading icon"
    })));
    _defineProperty(this, "orderDetail", (line_items, address, total_shipping_price_set, index) => /*#__PURE__*/React.createElement("div", {
      style: {
        borderLeft: "1px solid lightgrey",
        padding: "1em 0 1em 1.5em",
        margin: "0em 0em 1em 0em",
        display: this.state.show[index] ? "block" : "none"
      }
    }, address && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        paddingBottom: "8px",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://img.icons8.com/material-outlined/24/null/order-delivered.png",
      style: {
        opacity: "0.5",
        padding: "0 0.7em 0 0.25em"
      },
      alt: address
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "small-text"
    }, [address.name, address.phone || ""].filter(a => a).join(" ")), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: "small-text"
    }, [address.address1, address.address2 || "", address.city || "", address.country || "", address.zip || ""].filter(a => a).join(" ")))), total_shipping_price_set && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "8px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        opacity: "0.5",
        padding: "0 1em 5px 0.25em"
      }
    }, /*#__PURE__*/React.createElement("i", {
      class: "shipping fast icon"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "small-text"
    }, "\u904B\u8CBB"), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: "small-text"
    }, "$ ", total_shipping_price_set))), /*#__PURE__*/React.createElement("div", null, "$ ", total_shipping_price_set)), line_items.map(l => this.singleItem(l))));
    this.state = {
      show: [],
      draftOrder: [],
      revertForm: {},
      loading: false
    };
    this.handleShowOrderDetail = this.handleShowOrderDetail.bind(this);
  }
  componentDidMount() {
    const customerID = this.props.customerID;
    //this.setState({ draftOrder: sampledraftOrder });
    fetch("https://iheartzshop-api-2.herokuapp.com/v1/draft-order/public/" + customerID).then(res => res.json()).then(result => {
      document.getElementById("order_count").innerHTML = "<i class='clipboard outline icon' inverted></i> " + result.data.length;
      if(result.data.length == 0) document.getElementById("zero-order").style.display = "block";
      this.setState({
        show: new Array(result.data.length).fill(false),
        draftOrder: result.data
      });
    },
    // Note: it's important to handle errors here
    // instead of a catch() block so that we don't swallow
    // exceptions from actual bugs in components.
    error => {
      console.log(error);
      this.setState({
        isLoaded: true,
        error
      });
    });
  }
  render() {
    //console.log("this.state.revertForm", this.state);
    return /*#__PURE__*/React.createElement("div", {
      className: "App"
    }, this.wrapper());
  }
}

// Find all DOM containers, and render Like buttons into them.
document.querySelectorAll('.order_display_container')
  .forEach(domContainer => {
    // Read the comment ID from a data-* attribute.
    const customerID = parseInt(domContainer.dataset.customerid, 10);
    const root = ReactDOM.createRoot(domContainer);
    root.render(
      e(OrderDisplay, { customerID: customerID })
    );
  });